import React, { useEffect, useState } from "react";
import { adminApi } from "../../backend_urls/adminApi";
import LoadingSpinner from "../../components/loaders/LoadingSpinner";
import DynamicTable from "../../components/reusable/DynamicTable";
import BaseIcon from "../../components/svg_icons/BaseIcon";
import ReusableModal from "../../components/reusable/ReusableForm";

const AdminAllInvoicesPage = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);

    const fetchInvoicesData = async () => {
        try {
            const response = await adminApi.getAllInvoices();
            setData(response.data);
        } catch (error) { console.error("Error fetching invoices:", error);
        } finally { setLoading(false); };
    };
    useEffect(() => { fetchInvoicesData(); }, []);

    const handleCreateRecord = () => { setOpen(true); }
    const handleSubmit = (formData) => {
        const finalPayload = { ...formData };
        console.log("FINAL DATA 👉", finalPayload);
        // 👉 API call here
        setOpen(false);
    };

    const columns = [
        { key: "__sn", label: "Sr. No.", sortable: false },
        { key: "created_at", label: "Created on", sortable: false, tooltip: "Date of Invoice Generated/Uploaded on" },
        { key: "invoice_number", label: "Invoice Number", sortable: false },
        { key: "source", label: "Source", sortable: false, tooltip: "This invoice record is created by which source like Manual way or Uploaded by user" },
    ];

    const actions = [
        {
            icon: <BaseIcon name="eyeOpen" size={20} />,
            title: "View",
            onClick: (row) => console.log("View", row),
        },
        {
            icon: <BaseIcon name="trash" size={20} />,
            title: "Delete",
            className: "delete",
            onClick: (row) => console.log("Delete", row),
        },
    ];

    return ( loading ? <LoadingSpinner /> : (
        <>
            <h1>All generated invoices</h1>
            <button onClick={handleCreateRecord}>Create New Invoice</button>
            <DynamicTable
                columns={columns}
                data={data}
                itemsPerPage={10}
                onAction={actions}
            />

            <ReusableModal
                isOpen={open}
                onClose={() => setOpen(false)}
                title="Create Invoice"
                onSubmit={handleSubmit}
                fields={[
                    { name: "seller_name", label: "Seller Name" },
                    { name: "buyer_name", label: "Buyer Name" },
                    { name: "invoice_number", label: "Invoice Number" },
                    { name: "invoice_date", label: "Date", type: "date" },
                ]}
            />
        </>
    ));
};

export default AdminAllInvoicesPage;
